<template>
    <div v-loading="dataLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
            size="medium"
        >
            <div class="page-group-title"><span>基本信息</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="poster" label="活动列表封面:" :rules='[{required: true, message: "请上传活动列表封面"}]'>
                        <image-upload 
                            :url.sync="formData.poster" 
                            :urlFull.sync="formData.poster" 
                            ref="posterUpload"
                            class="poster-upload"
                            @onSuccess="handleImageSuccess"
                        >
                        </image-upload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="title" label="活动名称:" :rules='[{required: true, message: "请填写活动名称"}]'>
                        <el-input v-model.trim="formData.title" maxlength="15"></el-input>
                    </el-form-item>                    
                    <el-form-item prop="url" label="访问链接:" >
                        <el-input v-model.trim="formData.url"></el-input>
                    </el-form-item>
					<el-form-item prop="type" label="开奖模式:" :rules='[{required: true, message: "请选择开奖模式"}]'>
					    <el-radio-group v-model="formData.type" :disabled="formData.id && formData.id != ''">
					        <el-radio :label="1">即时开奖</el-radio>
					        <el-radio :label="2">定时开奖</el-radio>
					    </el-radio-group>
					</el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="startTime" label="活动开始时间:" :rules='[{required: true, message: "请填写活动开始时间"}]'>
                        <el-date-picker type="datetime" v-model="formData.startTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="endTime" label="活动结束时间:" :rules='[{required: true, message: "请填写活动结束时间"}]'>
                        <el-date-picker type="datetime" v-model="formData.endTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
			<el-row :gutter="30">
			    <el-col :xs="24" :sm="12" :xl="8">
			        <el-form-item prop="onTime" label="上线时间:" :rules='[{required: true, message: "请填写上线时间"}]'>
			            <el-date-picker type="datetime" v-model="formData.onTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>						
						<small><span class="el-icon-warning"></span>上线前乐迷端活动列表不展示该活动.</small>
			        </el-form-item>
			    </el-col>
			    <el-col :xs="24" :sm="12" :xl="8">
			        <el-form-item prop="offTime" label="下线时间:" :rules='[{required: true, message: "请填写下线时间"}]'>
			            <el-date-picker type="datetime" v-model="formData.offTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						<small><span class="el-icon-warning"></span>下线后乐迷端活动列表不展示该活动.</small>
			        </el-form-item>
			    </el-col>
			</el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="initNum" label="初始每人可抽次数:" :rules='[{required: true, message: "请填写初始每人可抽次数"}]' v-if="formData.type == 1">
                        <el-input-number style="width:100%" v-model="formData.initNum" :precision="0" controls-position="right" :min="0" :max="99999999"></el-input-number>
                    </el-form-item>
					<el-form-item prop="initNum" label="初始每人可抽次数:" :rules='[{required: true, message: "请填写初始每人可抽次数"}]' v-if="formData.type == 2">
					    <el-input style="width:100%" value="1" readonly ></el-input>
					</el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="winNum" label="每人最多抽中次数:" :rules='[{required: true, message: "请填写每人最多抽中次数"}]' v-if="formData.type == 1">
                        <el-input-number style="width:100%" v-model="formData.winNum" :precision="0" controls-position="right" :min="1" :max="99999999"></el-input-number>
                    </el-form-item>
					<el-form-item prop="winNum" label="每人最多抽中次数:" :rules='[{required: true, message: "请填写每人最多抽中次数"}]' v-if="formData.type == 2">					    
						<el-input style="width:100%" value="1" readonly ></el-input>
					</el-form-item>
                </el-col>
            </el-row>
			<el-row :gutter="30">
				<el-col :xs="24" :xl="16">
					<el-form-item prop="joinLimit" label="参与人限制:">
					    <el-radio-group v-model="formData.joinLimit">
					        <el-radio :label="1">全部用户</el-radio>
					        <el-radio :label="2">指定用户</el-radio>
					    </el-radio-group>
					</el-form-item>
					<el-card v-if="formData.joinLimit == 2" >
						<el-form-item label="演出消费用户:">
						    <span slot="label"><el-checkbox v-model="joinType1" @change="joinTypeFun1">演出消费用户：</el-checkbox></span>
						    <el-input placeholder="输入演出ID，多个ID用逗号分隔" v-model="sActivityIds">
						        <el-button slot="append" icon="el-icon-search" @click="searchActivity()">添加演出</el-button>
						    </el-input>
						    <el-table class="MT10" :data="sActivityList" size="mini" border stripe v-loading="sActivityLoading">
						        <el-table-column prop="id" label="演出ID" width="90"></el-table-column>
						        <el-table-column prop="name" label="演出名称" show-overflow-tooltip></el-table-column>						        
						        <el-table-column label="操作" width="80">
						            <template slot-scope="scope">
						                <el-button type="text" @click="delActivity(scope.row.id)">删除</el-button>
						            </template>
						        </el-table-column>
						    </el-table>
						</el-form-item>
						<el-form-item prop="goodsIds">
							<span slot="label"><el-checkbox v-model="joinType2" @change="joinTypeFun2">周边消费用户:</el-checkbox></span>
							<el-input placeholder="输入周边ID，多个ID用逗号分隔" v-model="sgoodsIds">
							    <el-button slot="append" icon="el-icon-search" @click="searchGoods()">添加商品</el-button>
							</el-input>
							<el-table class="MT10" :data="sgoodsList" size="mini" border stripe v-loading="sGoodsLoading">
							    <el-table-column prop="id" label="商品ID" width="90"></el-table-column>
							    <el-table-column prop="name" label="商品名称" show-overflow-tooltip></el-table-column>						        
							    <el-table-column label="操作" width="80">
							        <template slot-scope="scope">
							            <el-button type="text" @click="delGoods(scope.row.id)">删除</el-button>
							        </template>
							    </el-table-column>
							</el-table>
						    <!-- <el-input type="textarea" v-model="formData.goodsIds" placeholder="请填写周边ID" size="medium"
						        :maxlength="200"></el-input>
						    <small class="from-tip"><span class="el-icon-warning"></span>填写周边ID，多个ID之间用逗号分隔</small> -->
						</el-form-item>
						<el-form-item>
							<span slot="label"><el-checkbox v-model="joinType3">白名单用户</el-checkbox></span>
						</el-form-item>						
					</el-card>					
				</el-col>
			</el-row>
			<template v-if="formData.type == 1">
            <div class="page-group-title"><span>额外抽奖机会</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="extraInfo.shareNum" :rules='[{required: shareChecked ? true : false, message: "请填写每人最多可获得次数"}]'>
                        <span slot="label">分享获得: <el-checkbox v-model="shareChecked"><small>每分享1次，可获得1次</small></el-checkbox></span>
                        <template v-if="shareChecked">
                            <small>每人最多可获得次数：</small> 
                            <el-input-number v-model="formData.extraInfo.shareNum" :precision="0" controls-position="right" :min="1" :max="99999999"></el-input-number> 
                        </template>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="extraInfo.pullNewNum" :rules='[{required: pullNewChecked ? true : false, message: "请填写每人最多可获得次数"}]'>
                        <span slot="label">拉新获得: <el-checkbox v-model="pullNewChecked"><small>每成功拉新1人，可获得1次</small></el-checkbox></span>
                        <template v-if="pullNewChecked">
                            <small>每人最多可获得次数：</small> 
                            <el-input-number v-model="formData.extraInfo.pullNewNum" :precision="0" controls-position="right" :min="1" :max="99999999"></el-input-number> 
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>            
			<el-row :gutter="30">
			    <el-col :xs="24" :xl="16">
			        <el-form-item >
			            <span slot="label">分享活动被其他人打开获得: <el-checkbox v-model="openShareChecked"></el-checkbox></span>
			            <template v-if="openShareChecked">
			                <small>被</small> 
			                <el-input-number v-model="formData.extraInfo.openNum" :precision="0" controls-position="right" :min="1" :max="99999999"></el-input-number> 
			                <small>人打开后，可获得</small> 
			                <el-input-number v-model="formData.extraInfo.drawNum" :precision="0" controls-position="right" :min="1" :max="99999999"></el-input-number> 
			                <small>抽奖次数</small> 
			            </template>
			        </el-form-item>
			    </el-col>
			</el-row>
			<el-row :gutter="30">
			    <el-col :xs="24" :xl="16">
			        <el-form-item >
			            <span slot="label">积分兑换获得: <el-checkbox v-model="openPointChecked"></el-checkbox></span>
			            <template v-if="openPointChecked">
			                <small>单次抽奖所需秀豆：</small> 
			                <el-input-number v-model="formData.extraInfo.point" :precision="0" controls-position="right" :min="1" :max="999" class="MR20"></el-input-number> 
			                <small>每人最多可获得次数：</small> 
			                <el-input-number v-model="formData.extraInfo.pointNum" :precision="0" controls-position="right" :min="1" :max="999"></el-input-number> 
			            </template>
			        </el-form-item>
			    </el-col>
			</el-row>
			</template>
            <div class="page-group-title"><span>推荐设置</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="recommendActivityIds">
                        <span slot="label">推荐演出：
                            <!-- <el-checkbox v-model="shareChecked">置顶演出</el-checkbox> -->
                        </span>
                        <el-input v-model="formData.recommendActivityIds" placeholder="请填写演出ID" type="textarea"></el-input>
                        <small class="color-info">填写演出ID，多个ID之间用逗号分隔，填写顺序为演出展示顺序</small>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="recommendGoodsId">
                        <span slot="label">推荐周边：</span>
                        <el-input v-model="formData.recommendGoodsId" placeholder="请填写周边ID" type="textarea"></el-input>
                        <small class="color-info">填写周边ID，多个ID之间用逗号分隔，填写顺序为周边展示顺序</small>
                    </el-form-item>    
                </el-col>                
            </el-row>
			<div class="page-group-title"><span>活动说明</span></div>
			<el-row :gutter="30">			    
			    <el-col :xs="24" :xl="16">
			        <el-form-item prop="rule">
                        <tinymce v-model="formData.rule" :toolbar="toolbar" :menubar="false" v-if="reFresh"></tinymce>
						<small class="color-info">填写活动规则等信息</small>
                    </el-form-item>
			    </el-col>
			</el-row>
            <el-form-item class="MT30">
                <el-button @click="goBack">返回</el-button>
                <el-button 
                    v-if="$utils.have('/lottery/activity/edit')" 
                    type="primary" 
                    @click="onSubmit" 
                    :loading="btnLoading"
                >下一步</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import ImageUpload from '@/components/ImageUpload';
import Tinymce from '@/components/Tinymce'; 
const defaultFormData = {
    title: '',
    startTime:'',
    endTime:'',
	onTime:'',
	offTime:'',
    initNum: 1,
    winNum: 1,
    extraInfo: {
        shareNum: 1,
        pullNewNum: 1,
        openNum: 1,
        drawNum: 1,
		point:1,
		pointNum:1
    },
    poster: "",
    url: "",
    joinLimit: 1,
	type:1,
	whiteUser:0
}
export default {
    props:{
        id:{
            type: [String,Number],
            default: ''
        }
    },
    components:{Tinymce,ImageUpload},
    data(){
        return{
            dataLoading: false,
            formData: {
                ...defaultFormData
            },
            btnLoading:false,
            redirect: this.$route.query.redirect,
            rules:{},
            shareChecked: false,
            pullNewChecked: false,
            openShareChecked: false,
			openPointChecked:false,
			
			joinType1:'',
			joinType2:'',
			joinType3:'',
			sActivityIds: "",
			sActivityLoading: false,
			sActivityList: [],
			reFresh:false,
			v: this.$route.query.v || '',
			toolbar:['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media | preview fullscreen'],
			
			sgoodsList: [],
			sgoodsIds: "",
			sGoodsLoading: false,
        }
    },
    mounted(){
        if(this.id){
            this.getDataDetail();
        }else{
            this.reFresh = true;
        }
    },
    methods:{
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
		joinTypeFun1(val){
			if(!val){
				this.sActivityList = []
				this.sActivityIds=''
			}
		},
		joinTypeFun2(val){
			if(!val){
				this.sgoodsList = []
				this.sgoodsIds=''
			}
		},
        //获取详情
        getDataDetail(){
            this.dataLoading = true;
            this.$request({
                url: "/lottery/activity/detail",
                params: { id: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        const _extraInfo = JSON.parse(result.extraInfo)
                        this.formData = {
                            ...this.defaultFormData,
                            ...result,
                            extraInfo: {
                                ...this.formData.extraInfo,
                                ..._extraInfo
                            }
                        }
                        this.shareChecked = _extraInfo.shareNum ? true : false;
                        this.pullNewChecked = _extraInfo.pullNewNum ? true : false;
                        this.openShareChecked = _extraInfo.openNum ? true : false;
						this.openPointChecked = _extraInfo.point ? true :false,
						this.joinType1 = result.activityIds ? true :false
						this.joinType2 = result.goodsIds ? true :false
						this.joinType3 = result.whiteUser == 1 ? true :false
						
						this.sActivityIds = result.activityIds
						this.sgoodsIds = result.goodsIds
						if ( result.activityIds) {
							this.searchActivity();							
						}
						if ( result.goodsIds) {
							this.searchGoods();							
						}
						
						 this.reFresh = true;
						
                    } else {
                        this.$message.error(msg || "获取活动信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取活动信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
		//搜索演出
		searchActivity() {
		    if (this.sActivityIds) {
		        this.sActivityLoading = true;
		
		        this.sActivityIds = this.sActivityIds.replace(/，/g, ',');
		
		        let _sActivityIds = this.sActivityIds.split(',');
		        _sActivityIds.map((v, i) => _sActivityIds[i] = parseInt(v));
				
				
				this.$request({
				    url: "/activity/activityIdNameList",
				    method: 'post',
				    data: _sActivityIds
				})
				    .then((res) => {
				        const { state, msg, result } = res.data;
				        if (result && result.length > 0) {
				        	this.sActivityLoading = false;
				            result.map(item => {
				                if (!this.sActivityList.find(v => v.id == item.id)) {
				                    this.sActivityList.push(item)
				                }
				            })
							
				        } else {
							this.sActivityLoading = false;
				            this.$message.error(msg || '没有找到相关演出');
				        }
				    })
				    
			}
		},
		//删除演出
		delActivity(id) {
		    this.sActivityList = this.sActivityList.filter(v => v.id != id);
		},
		//搜索商品
		searchGoods() {
		    if (this.sgoodsIds) {
		        this.sGoodsLoading = true;
		
		        this.sgoodsIds = this.sgoodsIds.replace(/，/g, ',');
		
		        let _sgoodsIds = this.sgoodsIds.split(',');
		        _sgoodsIds.map((v, i) => _sgoodsIds[i] = parseInt(v));
				
				
				this.$request({
				    url: "/shop_good/goodsIdNameList",
				    method: 'post',
				    data: _sgoodsIds
				})
				    .then((res) => {
				        const { state, msg, result } = res.data;
				        if (result && result.length > 0) {
				        	this.sGoodsLoading = false;
				            result.map(item => {
				                if (!this.sgoodsList.find(v => v.id == item.id)) {
				                    this.sgoodsList.push(item)
				                }
				            })
							
				        } else {
							this.sGoodsLoading = false;
				            this.$message.error(msg || '没有找到相关周边');
				        }
				    })
				    
			}
		},
		//删除演出
		delGoods(id) {
		    this.sgoodsList = this.sgoodsList.filter(v => v.id != id);
		},
         //图片上传成功后执行 需要重置海报的水印图
        handleImageSuccess(){
            if(this.formData.poster){
                this.$refs["formData"].clearValidate('poster');
            }
        },
		
        //表单提交
        onSubmit(){
            this.$refs["formData"].validate((valid) => {
                let _extraInfo = {...this.formData.extraInfo}

                if( !this.shareChecked ){
                    delete _extraInfo.shareNum
                }
                if( !this.pullNewChecked ){
                    delete _extraInfo.pullNewNum
                }
                if( !this.openShareChecked ){
                    delete _extraInfo.openNum
                    delete _extraInfo.drawNum
                }
				if( !this.openPointChecked ){
				    delete _extraInfo.point
				}
				
				
				let _activityIds = [];
				let _goodsIds = []
				this.sActivityList.map(item => {
				    if(!item.ids || item.ids.length < 1){
				        _activityIds.push(item.id);
				    }
				})
				this.sgoodsList.map(item => {
				    if(!item.ids || item.ids.length < 1){
				        _goodsIds.push(item.id);
				    }
				})
				
				if( this.formData.joinLimit == 2 &&  !this.joinType1 && !this.joinType2  && !this.joinType3 ){
					return this.$message.error('请先选择参与人！');
				}
				if( this.joinType1 == true && _activityIds.length < 1 ){
					return this.$message.error('请先添加消费的演出！');
				}
				if( this.joinType2 == true && _goodsIds.length < 1 ){
					return this.$message.error('请先添加消费的周边');
				}
				
				this.formData.whiteUser = this.joinType3 == true ? 1 : 0
				
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: "/lottery/activity/edit",
                        method: "POST",
                        data: {
                            ...this.formData, 
                            extraInfo: JSON.stringify(_extraInfo),
                            id: this.id || '',
							activityIds: _activityIds.toString(),
							goodsIds:_goodsIds.toString()
                        },
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg, result } = res.data;
                            if (state && state == 1) {
                                // this.goBack();
                                this.$router.push({
                                    path:`/promotion/lottery/edit/${result}/step2`,
                                    query: {
                                        redirect: this.redirect,
                                    },
                                })
								
								this.joinType1 = false
								this.joinType2 = false
								this.joinType3 = false
                            } else {
								this.joinType1 = false
								this.joinType2 = false
								this.joinType3 = false
                                return this.$message.error(msg || "操作失败");								
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },

    }
}
</script>
<style lang="scss" scoped>

</style>